// The wils.trade mark — "Gust" (operator's pick, 2026-09-28): three wind lines,
// one weight, the top curl turns up and the bottom curl turns down, the whole
// mark leans with one shear. Geometry is the canonical vector
// wiki/design/logo/gust-gradient.svg (true 3/4 arcs, stroke 12, round caps);
// do not redraw it here — change the wiki file first.

import { useId } from 'react'

export function GustMark({ height = 26, className }: { height?: number; className?: string }) {
  // one gradient per instance: two marks on a page must not share an id
  const gradient = `gust-${useId().replace(/:/g, '')}`
  return (
    <svg
      className={className}
      width={Math.round((height * 106) / 112)}
      height={height}
      viewBox="-19 -30 106 112"
      fill="none"
      aria-hidden="true"
      focusable="false"
    >
      <defs>
        <linearGradient
          id={gradient}
          gradientUnits="userSpaceOnUse"
          x1="-19"
          y1="82"
          x2="87"
          y2="-30"
        >
          <stop offset="0" stopColor="#1F4CE0" />
          <stop offset="1" stopColor="#5A88FF" />
        </linearGradient>
      </defs>
      <g
        transform="matrix(1 0 -0.12 1 6.24 0)"
        stroke={`url(#${gradient})`}
        strokeWidth="12"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M4 0H60A12 12 0 1 0 48 -12" />
        <path d="M-16 26H48" />
        <path d="M12 52H70A12 12 0 1 1 58 64" />
      </g>
    </svg>
  )
}
